import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import UsersTable from '../components/UserTable';
import useUserList from '../hooks/reactQuery/useUserList';
import useListPage, { initialParams } from '../hooks/useListPage';
import { usePublishPageMeta } from '../context/PageMeta';

interface IProps {
  handleModalOpen: (data: any) => void;
}

const Users = ({ handleModalOpen }: IProps) => {
  const [params] = useState(initialParams);
  const [firstName, setFirstName] = useState(params.get('firstName') ?? '');
  const [lastName, setLastName] = useState(params.get('lastName') ?? '');
  const [email, setEmail] = useState(params.get('email') ?? '');
  const [roles, setRoles] = useState<string[]>(
    () => params.get('role')?.split('|').filter(Boolean) ?? [],
  );

  const filter = {
    firstName,
    lastName,
    email,
    role: roles.length ? roles.join('|') : undefined,
  };
  const {
    currentPage,
    setCurrentPage,
    pageSize,
    onPageSizeChange,
    isAuto,
    fitSize,
  } = useListPage(270, JSON.stringify(filter));

  const { data, isLoading, isFetching, refetch, dataUpdatedAt } = useUserList({
    limit: pageSize,
    page: currentPage,
    filter,
  });
  usePublishPageMeta({ total: data?.total, dataUpdatedAt, refetch });

  return (
    <div className="main-content">
      {isLoading ? (
        <div className="spinner-position">
          <Spinner />
        </div>
      ) : (
        <UsersTable
          data={data}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          handleModalOpen={handleModalOpen}
          itemsPerPage={pageSize}
          onPageSizeChange={onPageSizeChange}
          isAutoPageSize={isAuto}
          fitPageSize={fitSize}
          isFetching={isFetching}
          firstName={firstName}
          lastName={lastName}
          email={email}
          roles={roles}
          setFirstName={setFirstName}
          setEmail={setEmail}
          setLastName={setLastName}
          setRoles={setRoles}
        />
      )}
    </div>
  );
};

export default Users;
